import { Match } from "effect";
import { INTERNAL_HTTP_MESSAGE } from "@workerstation/shared/errors/http";
import type { ChatClientFailure } from "./model.ts";
export const chatFailureMessage = (failure: ChatClientFailure): string => Match.value(failure).pipe(
  Match.tag("ChatClientRequestError", value => value.message),
  Match.tag("ResourceStorageError", () => INTERNAL_HTTP_MESSAGE),
  Match.exhaustive
);
